import React from 'react';
import '../css/Terms.css';
import { Link } from 'react-router-dom';


const Terms = () => {
    return (
        <>
            <div className="terms-container">
                <h2>Políticas de privacidad</h2>
                <p>Esta Política de Privacidad describe cómo CONDAMIND utiliza su información personal a través de nuestro
                    sitio
                    web: <strong>https://condamind.com</strong>, nuestras interacciones con usted a través de otros modos de
                    comunicación
                    (mensajería instantánea o correo electrónico) utilizando nuestra marca CONDAMIND y cualquier otro sitio
                    o
                    servicio vinculado a esta Política de Privacidad (colectivamente, los "Servicios").
                </p>
                <h3>Nuestro enfoque general</h3>
                <p>La vanguardia tecnológica abarca la inteligencia artificial en la comunicación. Estimamos que este nuevo
                    avance modificará de raíz la manera en que interactuamos y percibimos la presencia de ordenadores en
                    nuestra
                    rutina diaria. En esencia, nuestro propósito radica en emplear la IA para generar compañeros confiables,
                    perspicaces, cordiales y atractivos.</p>
                <p>Nuestro compromiso de privacidad refleja nuestra convicción de que alcanzar esta meta y hacer que la
                    tecnología sea genuinamente beneficiosa para todos exige una comprensión detallada de cómo nuestros
                    usuarios
                    se comunican y colaboran con las IA. A medida que los usuarios se relacionan con nuestras IA, obtenemos
                    valiosos conocimientos sobre cómo mejorar y hacer más útil la IA para su beneficio.</p>
                <p>Los usuarios merecen claridad en relación al funcionamiento de este proceso, especialmente cuando se
                    trata de
                    sus datos. Esta política constituye una parte esencial de esa transparencia. Documenta qué información
                    recolectamos, cómo la resguardamos y detalla cómo utilizamos esos datos para mejorar nuestros servicios
                    en
                    beneficio de todos. A continuación, se presentan los puntos más importantes:</p>
                <ul>
                    <li>Cuando utiliza Conda, recopilamos datos que incluyen su nombre, número de teléfono, correo
                        electrónico y
                        dirección IP. Usamos estos datos para ejecutar Conda, informar mejoras a la plataforma, mantenerte
                        seguro y cumplir con todas las leyes aplicables.</li>
                    <li>Mantener tus conversaciones con Conda privadas y seguras es nuestra máxima prioridad, y nunca
                        venderemos
                        ni compartiremos tus datos con fines publicitarios o de marketing. </li>
                    <li>Aceptas seguir nuestra política de Uso Aceptable. Cuando hables con Conda, no debes intentar que
                        hable
                        sobre temas dañinos, abusivos o ilegales. Tampoco debe intentar evadir nuestras medidas de seguridad
                        ni
                        conocer los modelos, algoritmos, indicaciones o código fuente de Conda. Si nuestros sistemas
                        automatizados detectan esta actividad, es posible que se le suspenda</li>
                    <li>No tienes permitido utilizar Conda si eres menor de 18 años</li>
                    <li>Conda puede inventar hechos, acontecimientos o consejos. Nunca debes confiar en nada de lo que te
                        dice
                        sin verificar los hechos tú mismo o, si corresponde, hablar con un profesional.</li>
                </ul>
                <h3>Información que recopilamos</h3>
                <p>Información que usted nos proporciona:</p>
                <ul>
                    <li>Información de contacto y de cuenta, como su nombre y apellido, dirección de correo electrónico y su
                        número de teléfono.</li>
                    <li>Contenido y metadatos de cualquier mensaje que envíe utilizando los Servicios o directamente a
                        CONDAMIND.</li>
                    <li>Comunicaciones que intercambiamos con usted, incluso cuando responde a nuestras encuestas o se
                        comunica
                        con nosotros si tiene preguntas, comentarios o de otro modo.</li>
                    <li>Otros datos no enumerados específicamente aquí, que usaremos como se describe en esta Política de
                        Privacidad o como se divulga de otro modo en el momento de la recopilación.</li>
                </ul>
                <h3>Cómo utilizamos su información:</h3>
                <p>Usamos información personal para los siguientes propósitos o como se describe de otro modo en el momento
                    de
                    la recopilación:</p>
                <h3>Proporcionar nuestros Servicios:</h3>
                <p>Usamos información personal para operar, mantener y brindarle nuestros Servicios. En particular,
                    utilizamos
                    información personal para cumplir con nuestras obligaciones contractuales según nuestros Términos de
                    servicio.</p>
                <h3>Comunicarnos con usted acerca de nuestros Servicios:</h3>
                <p>Es de nuestro interés comercial legítimo utilizar información personal para responder a sus solicitudes,
                    brindarle atención al cliente y comunicarnos con usted acerca de nuestros Servicios, incluso mediante el
                    envío de anuncios, encuestas, recordatorios y actualizaciones, alertas de seguridad y mensajes
                    administrativos y de soporte.</p>
                <h3>Mejorar, monitorear, personalizar y proteger nuestros Servicios:</h3>
                <p> Es de nuestro interés comercial legítimo mejorar y mantener nuestros Servicios seguros para nuestros
                    usuarios, lo que incluye:</p>
                <ul>
                    <li>Comprender sus necesidades e intereses y personalizar su experiencia con los Servicios y nuestras
                        comunicaciones.</li>
                    <li>Solución de problemas, pruebas e investigación, y mantenimiento de la seguridad de los Servicios.
                    </li>
                    <li>Investigar y proteger contra actividades fraudulentas, dañinas, no autorizadas o ilegales.</li>
                </ul>
                <h3>Investigación y desarrollo:</h3>
                <p>Podemos utilizar información personal con fines de investigación y desarrollo cuando sea de nuestro
                    interés
                    comercial legítimo, incluido el análisis y la mejora de los Servicios y nuestro negocio. Como parte de
                    estas
                    actividades, podemos crear o utilizar datos agregados, anonimizados u otros datos anonimizados a partir
                    de
                    la información personal que recopilamos. Convertimos la información personal en datos anónimos
                    eliminando
                    información que hace que los datos sean personalmente identificables para usted. Podemos utilizar estos
                    datos anónimos y compartirlos con terceros para nuestros fines comerciales legales, incluido analizar y
                    mejorar los Servicios y promover nuestro negocio.</p>
                <h3>Cumplimiento y protección:</h3>
                <p> Podemos utilizar información personal para cumplir con obligaciones legales y para defendernos contra
                    reclamos o disputas legales, incluso para:</p>
                <ul>
                    <li>Proteger nuestros derechos, privacidad, seguridad o propiedad, los suyos o los de otros (incluso
                        presentando y defendiendo reclamos legales).</li>
                    <li>Auditar nuestros procesos internos para el cumplimiento de los requisitos legales, contractuales y
                        políticas internas.</li>
                    <li>Hacer cumplir los términos y condiciones que rigen los Servicios.</li>
                    <li>Prevenir, identificar, investigar e impedir actividades fraudulentas, dañinas, no autorizadas, poco
                        éticas o ilegales, incluidos los ciberataques y el robo de identidad.</li>
                    <li>Cumplir con las leyes aplicables, solicitudes legales y procesos legales, como para responder a
                        citaciones o solicitudes de autoridades gubernamentales.</li>
                </ul>
                <h3>Consentimiento para Compartir Datos con Terceros</h3>
                <h3>Al aceptar estas Políticas de Privacidad, el usuario reconoce y acepta que la información podrá ser
                    compartida con terceros según lo especificado en los siguientes puntos relacionados con la Compartición
                    de
                    Información:</h3>
                <h3>Compartición de Información:</h3>
                <p>Si bien no tenemos la intención de compartir o vender datos con fines publicitarios o de marketing,
                    actuaremos como intermediarios entre el usuario y el negocio deseado. Esto incluirá la intermediación de
                    comunicaciones entre el usuario y el negocio con el que desean interactuar.</p>
                <h3>Papel de CONDAMIND como Intermediario y Control de Datos:</h3>
                <p> CONDAMIND actúa como intermediario entre el usuario y el negocio deseado para facilitar la comunicación
                    y la
                    interacción entre ambas partes. En este papel de intermediario, CONDAMIND administra la transmisión de
                    información entre el usuario y el negocio, pero no controla ni retiene permanentemente todos los datos
                    intercambiados.</p>
                <p>La información proporcionada por el usuario y compartida con el negocio se transfiere directamente a este
                    último, facilitando la comunicación y el servicio solicitado por el usuario. CONDAMIND no retiene la
                    totalidad de los datos intercambiados entre el usuario y el negocio, actuando principalmente como un
                    canal
                    de comunicación.</p>
                <p>No obstante, para facilitar y mejorar el servicio, CONDAMIND puede retener ciertos datos relacionados con
                    la
                    interacción, como registros de comunicaciones o metadatos que ayuden a mejorar la experiencia del
                    usuario.
                    Los datos retenidos por CONDAMIND están sujetos a las políticas de privacidad establecidas y son
                    utilizados
                    exclusivamente para optimizar y ofrecer un mejor servicio al usuario.</p>
                <p>Es importante destacar que la información compartida directamente entre el usuario y el negocio no es
                    controlada ni accesible por CONDAMIND una vez transmitida al negocio correspondiente. La gestión y el
                    tratamiento de esta información por parte del negocio estarán sujetos a las políticas de privacidad y
                    términos de uso de dicha entidad, y CONDAMIND no asume responsabilidad sobre el manejo de esos datos una
                    vez
                    transferidos.</p>
                <h3>Cómo Compartimos la Información con Nuestros Clientes (dueños de tiendas/negocios con los que el usuario
                    quiere interactuar):</h3>
                <h3>Proveedores de servicios:</h3>
                <p>Podemos confiar en terceros proveedores de servicios para cumplir con los fines previamente descritos.
                    Estos
                    terceros pueden acceder a la información personal y procesarla o almacenarla en nuestro nombre,
                    incluyendo
                    servicios de alojamiento, almacenamiento en la nube, mantenimiento, seguridad y atención al cliente.
                    También
                    podemos compartir hashes de nombres, números de teléfono y datos limitados del dispositivo para medición
                    y
                    atribución publicitaria.</p>
                <h3>Transferencias comerciales:</h3>
                <p>En caso de quiebra, cambio de control o cierre de CONDAMIND, la información personal puede transferirse a
                    otra entidad. Asimismo, en el contexto de una venta o fusión empresarial, también se puede transferir
                    información personal.</p>
                <h3>Autoridades y otros:</h3>
                <p>Si estamos legalmente obligados o consideramos que es necesario, la información personal puede ser
                    divulgada
                    a agencias regulatorias, fuerzas de seguridad, tribunales u otras autoridades gubernamentales para
                    cumplir
                    con fines de aplicación de la ley y protección.</p>
                <h3>Responsabilidad sobre Datos Compartidos con Terceros:</h3>
                <p>CONDAMIND reconoce y declara explícitamente que, una vez que la información personal ha sido compartida
                    con
                    terceros según los términos y condiciones establecidos en las políticas de privacidad, la
                    responsabilidad
                    sobre el manejo y tratamiento de dichos datos queda fuera de su alcance y competencia. En este sentido,
                    CONDAMIND no se hace responsable ni controla las prácticas de privacidad, políticas o procedimientos de
                    terceros que pudieran recibir información personal del usuario.</p>
                <p>Es responsabilidad del usuario estar consciente de que, una vez que la información personal ha sido
                    compartida con terceros, la protección y manejo de esos datos quedan sujetos a las políticas de
                    privacidad y
                    términos de uso de dichos terceros. CONDAMIND no se responsabiliza de las acciones, manejo o uso de la
                    información por parte de terceros, independientemente de los términos y condiciones establecidos en las
                    políticas de privacidad de CONDAMIND.</p>
                <p>Además, CONDAMIND aconseja encarecidamente a los usuarios revisar las políticas de privacidad de los
                    negocios/tiendas con los que interactúan a través de su servicio. Esto asegura que los usuarios estén
                    plenamente informados sobre cómo se manejan sus datos por parte de dichos negocios o entidades. Al
                    comprender y aceptar las políticas de privacidad de los terceros, los usuarios pueden tomar decisiones
                    más
                    informadas al compartir su información personal.</p>
                <h3>Acceso, Corrección y Eliminación de Datos Personales:</h3>
                <p>CONDAMIND se compromete a proporcionar un procedimiento accesible para que los usuarios accedan, corrijan
                    o
                    eliminen sus datos personales según sea necesario. Los usuarios tienen la opción de solicitar la
                    eliminación
                    o corrección de sus datos personales contactándose por correo electrónico a matias@condamind.com.
                    CONDAMIND
                    se esforzará por responder y atender estas solicitudes de manera oportuna y efectiva, de acuerdo con las
                    leyes y regulaciones aplicables.</p>
                <h3>Derechos y Opciones de Privacidad</h3>
                <h3>Eliminación de cuenta:</h3>
                <p> Puede solicitar la eliminación de su cuenta comunicándose con nosotros según lo indicado en la sección
                    "Cómo
                    contactarnos" a continuación.</p>
                <h3>Solicitudes de información personal.</h3>
                <p>Le ofrecemos opciones que afectan la forma en que manejamos la información personal que controlamos.
                    Dependiendo de su ubicación y la naturaleza de sus interacciones con nuestros Servicios, puede solicitar
                    lo
                    siguiente en relación con su información personal: Solicitudes de información personal. Le ofrecemos
                    opciones que afectan la forma en que manejamos la información personal que controlamos. Dependiendo de
                    su
                    ubicación y la naturaleza de sus interacciones con nuestros Servicios, puede solicitar lo siguiente en
                    relación con su información personal:</p>
                <ul>
                    <li><strong>Información</strong> sobre cómo hemos recopilado y utilizado información personal. Hemos
                        puesto
                        esta información a su disposición sin tener que solicitarla incluyéndola en esta Política de
                        Privacidad.
                    </li>
                    <li><strong>Acceso</strong> a una copia de la información personal que hemos recopilado sobre usted.
                        Cuando
                        corresponda, proporcionaremos la información en un formato portátil, legible por máquina y
                        fácilmente
                        utilizable.</li>
                    <li><strong>Corrección</strong> de información personal que sea inexacta o esté desactualizada.</li>
                    <li><strong>Eliminación</strong> de información personal que ya no necesitamos para proporcionar los
                        Servicios o para otros fines legales.</li>
                    <li><strong>Retirada del consentimiento</strong>, cuando hemos recopilado y procesado su información
                        personal con su consentimiento. Retirar su consentimiento no afectará la legalidad de ningún
                        procesamiento que hayamos realizado antes de su retiro, ni afectará el procesamiento de su
                        información
                        personal realizado basándose en motivos de procesamiento legales distintos del consentimiento.</li>
                    <li><strong>Derechos adicionales</strong>, como objetar y solicitar que restringamos nuestro uso de
                        información personal.</li>
                </ul>
                <p>Para realizar una solicitud, envíenos un correo electrónico o escríbanos según lo dispuesto en la sección
                    "Cómo contactarnos" a continuación. Es posible que le solicitemos información específica para ayudarnos
                    a
                    confirmar su identidad. Dependiendo de dónde resida, es posible que tenga derecho a autorizar a un
                    agente
                    autorizado a presentar solicitudes en su nombre. Requeriremos que los agentes autorizados confirmen su
                    identidad y autoridad, de acuerdo con las leyes aplicables. Tiene derecho a ejercer los derechos
                    descritos
                    anteriormente sin sufrir discriminación.</p>
                <p>Límites a sus derechos y opciones de privacidad. En algunos casos, sus opciones pueden ser limitadas,
                    como
                    cuando cumplir con su solicitud afectaría los derechos de otros, nuestra capacidad de proporcionar un
                    servicio que usted ha solicitado o nuestra capacidad de cumplir. con nuestras obligaciones legales y
                    hacer
                    cumplir nuestros derechos legales. Si no está satisfecho con la forma en que abordamos su solicitud,
                    puede
                    presentar una queja comunicándose con nosotros según lo dispuesto en la sección "Cómo contactarnos" a
                    continuación. Dependiendo de dónde resida, es posible que tenga derecho a presentar una queja ante un
                    regulador de protección de datos donde vive o trabaja, o donde cree que se ha producido una infracción.
                </p>
                <h3>Política de Retención de Datos</h3>
                <p>En CONDAMIND, estamos comprometidos con la gestión responsable de los datos de nuestros usuarios y
                    clientes.
                    Entendemos la importancia de proteger su privacidad y garantizar la seguridad de su información
                    personal. En
                    línea con este compromiso, la presente sección detalla nuestra política de retención de datos.</p>
                <h3>Duración de la Retención de Datos:</h3>
                <ul>
                    <li><strong>Período de Retención Estándar:</strong> Conservaremos su información personal durante un
                        período
                        de un año desde la fecha de su última interacción con nuestros servicios. Este período de retención
                        nos
                        permite utilizar los datos para mejorar nuestros servicios, proporcionar soporte al cliente,
                        realizar
                        análisis internos y cumplir con nuestras obligaciones legales y reglamentarias.</li>
                    <li><strong>Datos Sensibles y Críticos:</strong> Algunos tipos de datos, debido a su naturaleza sensible
                        o
                        crítica, pueden estar sujetos a un período de retención diferente, ya sea más corto o más largo,
                        según
                        lo exijan las leyes aplicables o las necesidades específicas del negocio.</li>
                </ul>
                <h3>Finalización del Período de Retención:</h3>
                <h3>Al finalizar el período de retención de un año:</h3>
                <ul>
                    <li><strong>Eliminación y Anonimización:</strong> Procederemos a eliminar o anonimizar su información
                        personal de manera que ya no pueda asociarse con usted o identificarlo como individuo, excepto en
                        casos
                        donde existan requerimientos legales o reglamentarios que exijan una retención más prolongada.</li>
                    <li><strong>Revisión de Datos:</strong> Revisaremos periódicamente los datos almacenados para garantizar
                        que
                        la información que ya no sea necesaria sea eliminada o anonimizada de manera oportuna y segura.</li>
                </ul>
                <h3>Derechos del Usuario:</h3>
                <p>Usted tiene derecho a solicitar acceso, corrección o eliminación de sus datos personales en cualquier
                    momento
                    durante el período de retención. Si tiene preguntas o solicitudes relacionadas con sus datos, por favor
                    contáctenos utilizando los detalles proporcionados en la sección "Cómo contactarnos".</p>
                <h3>Cambios en la Política de Retención:</h3>
                <p>Nos reservamos el derecho de modificar esta política de retención de datos. Cualquier cambio
                    significativo
                    será comunicado a través de nuestra página web o por medio de un aviso directo a los usuarios.</p>
                <h3>Seguridad</h3>
                <p>La seguridad es fundamental para el éxito de la IA conversacional: las personas deben confiar en que sus
                    datos se manejan de manera responsable y segura para poder obtener todos los beneficios de nuestros
                    Servicios.</p>
                <p>Garantizar la integridad de sus datos es una prioridad importante para nosotros. CONDAMIND cuenta con
                    medidas
                    técnicas para proteger la información personal contra el acceso no autorizado, la corrupción, la pérdida
                    o
                    el uso indebido. Esto incluye medidas internas que limitan el acceso a la información personal a un
                    conjunto
                    dedicado de empleados especializados que trabajan para mejorar la seguridad o la calidad de nuestros
                    Servicios. Cuando sea posible y apropiado, también desidentificamos datos confidenciales, como registros
                    de
                    conversaciones, para preservar la privacidad del usuario.</p>
                <p>Sin embargo, estas medidas no son garantía de seguridad absoluta y usted reconoce y acepta que el uso de
                    nuestros Servicios es, en última instancia, bajo su propio riesgo.</p>
                <p>Además, tenga en cuenta que usted es responsable de administrar el acceso a cualquier cuenta que mantenga
                    con
                    CONDAMIND. No limitar el acceso a sus dispositivos o navegador podría permitir que terceros tengan
                    acceso no
                    autorizado a su información personal.</p>
                <h3>Niños</h3>
                <p>Nuestros Servicios no están destinados a menores de 18 años. No recopilamos ni solicitamos
                    intencionalmente
                    información personal de menores de 18 años. Si es menor de 18 años, no intente utilizar nuestros
                    Servicios.
                    registrar una cuenta con nosotros o enviarnos cualquier información personal.</p>
                <p>Si cree que un menor de 18 años nos ha proporcionado información personal o está utilizando nuestros
                    Servicios, infórmenos de inmediato a matias@condamind.com y buscaremos eliminar esta información y
                    revocar
                    el acceso lo más rápido posible.</p>
                <h3>Retención</h3>
                <p>Cuando lo exijan las leyes aplicables, conservamos información personal solo durante el tiempo necesario
                    para
                    cumplir con los fines para los cuales fue recopilada y procesada, de acuerdo con nuestras políticas de
                    retención y de acuerdo con las leyes y obligaciones reglamentarias aplicables o hasta que usted retire
                    su
                    consentimiento (cuando corresponda).</p>
                <p>Para determinar el período de retención apropiado para la información personal, consideramos la cantidad,
                    naturaleza y sensibilidad de la información personal, el riesgo potencial de daño por el uso o
                    divulgación
                    no autorizados de la información personal, los propósitos para los cuales usamos la información personal
                    y
                    si podemos lograr esos propósitos a través de otros medios, y los requisitos legales y reglamentarios
                    aplicables.</p>
                <h3>Cambios a esta política</h3>
                <p>Continuamos desarrollando y mejorando nuestros Servicios y será necesario actualizar esta Política de
                    Privacidad. Tenga en cuenta que nos reservamos el derecho de modificar esta Política de Privacidad en
                    cualquier momento.</p>
                <p>Cuando lo hagamos y a menos que la ley nos exija proporcionar un aviso alternativo, publicaremos una
                    versión
                    actualizada en esta página. Si elige continuar usando nuestros Servicios después de dicha revisión,
                    acepta
                    regirse por la Política de Privacidad modificada.</p>
                <h3>Contáctenos</h3>
                <h3>Entidad responsable:</h3>
                <p>CONDAMIND es la entidad responsable del procesamiento de información personal según esta Política de
                    Privacidad (como controlador, cuando lo establezca la ley aplicable).</p>
                <p>Comuníquese con el equipo de CONDAMIND en matias@condamind.com si tiene alguna pregunta o inquietud con
                    respecto a esta Política de privacidad.</p>
                <h3>Nuestros servicios</h3>
                <p>CONDAMIND sostiene que la IA en el diálogo transformará en su esencia la manera en que nos comunicamos y
                    empleamos las computadoras en nuestra rutina cotidiana. Al interactuar con nuestros servicios,
                    adquiriremos
                    un mayor entendimiento sobre cómo mejorar progresivamente esta novedosa tecnología para que sea más
                    útil,
                    colaborativa y entretenida en la interacción.</p>
                <p>Dada la etapa inicial de este desarrollo tecnológico, también admitimos la existencia de áreas que
                    requerirán
                    mejoras constantes para asegurar que nuestros servicios puedan desplegar su máximo potencial. Como parte
                    de
                    esto, reconoces que:</p>
                <ul>
                    <li>Utilizaremos el contenido de sus conversaciones para mejorar nuestros Servicios. Utilizaremos el
                        contenido de sus conversaciones, así como otros metadatos, para entrenar nuestros modelos, mejorar
                        nuestros Servicios y crear nuevos Servicios. Nuestros usos de estos datos se detallan en nuestra
                        Política de Privacidad.</li>
                    <li>Debe utilizar nuestros Servicios de acuerdo con nuestra política de Uso Aceptable. Su acceso a
                        nuestros
                        Servicios está condicionado a su aceptación de utilizar los Servicios de acuerdo con estos Términos
                        en
                        general y nuestra política de Uso Aceptable (como se detalla a continuación en "Uso Aceptable").
                    </li>
                    <li>La información que reciba de nuestros Servicios puede no ser precisa. Usted reconoce que cualquier
                        información que reciba de nuestros Servicios puede no ser precisa o no confiable. No confíe en esta
                        información sin antes verificarla usted mismo o consultar con un profesional. Acertar con la
                        factualidad
                        sigue siendo un área activa de investigación para todo el campo de la IA conversacional, y sigue
                        siendo
                        una prioridad importante para el desarrollo de los servicios de IA de CONDAMIND en el futuro. Revise
                        la
                        sección "Sin garantías" a continuación.</li>
                </ul>
                <h3>Registro para nuestros servicios</h3>
                <p>Usted se registra en nuestros Servicios proporcionándonos su nombre, número de teléfono y correo
                    electrónico.
                    Al hacerlo, usted acepta:</p>
                <ul>
                    <li>Proporcionarnos información de registro completa y precisa. No puede utilizar un número de teléfono
                        que
                        no controle y no puede intentar hacerse pasar por otra persona al registrarse.</li>
                    <li>Si se registra en nuestros Servicios en nombre de una organización, garantiza que está autorizado a
                        aceptar estos Términos en su nombre.</li>
                    <li>Ser responsable de la seguridad de su cuenta. Acepta que es el único responsable de todas las
                        actividades que se llevan a cabo a través de su cuenta y que no limitar el acceso a sus dispositivos
                        o
                        navegador puede permitir el uso no autorizado por parte de terceros.</li>
                </ul>
                <p>Finalmente, nuestros Servicios no están destinados a menores de 18 años. Si es menor de 18 años, no se
                    registre en nuestros Servicios ni nos envíe ninguna Información personal. Si tiene motivos para creer
                    que un
                    menor de 18 años está utilizando nuestros Servicios, infórmenos de inmediato a matias@condamind.com e
                    intentaremos revocar el acceso y eliminar cualquier información asociada lo más rápido posible.</p>
                <h3>Uso aceptable</h3>
                <p>Usted acepta que utilizará nuestros Servicios de acuerdo con las siguientes reglas, así como con
                    cualquier
                    otra política escrita que podamos proporcionar de vez en cuando:</p>
                <ul>
                    <li>Uso ilegal: Debe utilizar nuestros Servicios de conformidad con la ley. Si su uso de nuestros
                        Servicios
                        está limitado por las leyes que le aplican, no está autorizado a utilizar nuestros Servicios para
                        ese
                        propósito.</li>
                    <li>Usos nocivos: No puede utilizar ni intentar utilizar nuestros Servicios para generar contenido
                        dañino.
                        Dicho contenido incluye material que puede provocar daños graves a usted o a otros, contenido
                        relacionado con comportamientos poco éticos o contenido que puede difundir información errónea. Esta
                        política también prohíbe los intentos de utilizar los Servicios para crear contenido que se presente
                        de
                        manera fraudulenta como generado por humanos.</li>
                    <li>Contenido abusivo: No puede usar ni intentar usar nuestros Servicios para generar contenido que
                        incite
                        al odio o discriminatorio, contenido sexualmente explícito, descripciones de violencia gráfica u
                        otros
                        tipos de material impactante.</li>
                    <li>Infracción de derechos: No puede utilizar ni intentar utilizar nuestros Servicios para infringir o
                        violar los derechos de otros, incluidas las violaciones de la privacidad de otros. Esto incluye
                        consultas para revelar información personal de personas, incluidos números de teléfono, direcciones
                        y
                        otros datos confidenciales similares.</li>
                    <li>Seguridad: No puede intentar interactuar con nuestros Servicios en un esfuerzo por deshabilitar,
                        interrumpir o subvertir de otro modo la seguridad de nuestros Servicios. Esto incluye intentos de
                        eludir
                        o deshabilitar cualquier moderación de contenido y medidas de seguridad implementadas dentro de
                        nuestros
                        Servicios.</li>
                    <li>Ingeniería inversa: No puede usar ni intentar usar nuestros Servicios para realizar ingeniería
                        inversa,
                        descompilar o intentar obtener los modelos, algoritmos o código fuente subyacentes de los Servicios.
                        No
                        puede participar en esta ni ninguna otra actividad con respecto a nuestros Servicios para crear
                        productos que puedan ser competitivos con CONDAMIND.</li>
                    <li>Scraping: No puede extraer ni intentar "rastrear" o "rastrear" ninguna página, dato o parte de
                        nuestros
                        Servicios, ya sea por medios manuales o automatizados.</li>
                </ul>
                <h3>Contenido</h3>
                <p>Usted ingresará texto y otras formas de medios ("Contenido") durante el uso de nuestros Servicios. Usted
                    acepta que no ingresará ningún Contenido que no sea de su propiedad a menos que tenga el consentimiento
                    previo por escrito del titular de derechos correspondiente de ese Contenido.</p>
                <p>Si bien usted será propietario de cualquier Contenido, acepta proporcionar una licencia libre de
                    regalías,
                    perpetua, irrevocable y mundial a CONDAMIND sobre el Contenido para los siguientes propósitos limitados:
                </p>
                <ul>
                    <li>Operación de los Servicios: Usted otorga a CONDAMIND una licencia para usar, reproducir, modificar o
                        actuar de otro modo sobre el Contenido para permitir la prestación y el mantenimiento de los
                        Servicios.
                        Esto incluye usos para cumplir con las leyes aplicables, permitir la prestación de nuestros
                        Servicios a
                        través de canales y plataformas, garantizar la seguridad del usuario y hacer cumplir nuestras
                        políticas.
                    </li>
                    <li>Mejora de los Servicios: Usted otorga a CONDAMIND una licencia para usar el Contenido para mejorar
                        nuestros Servicios y desarrollar nuevos Servicios. Esta licencia permitirá usos que incluyen, entre
                        otros, el análisis del contenido de las conversaciones para comprender las oportunidades de nuevas
                        funciones, el uso del Contenido para la capacitación y el ajuste de modelos, y la evaluación del
                        desempeño de nuestros Servicios existentes.</li>
                </ul>
                <p>Esta licencia debe leerse junto con nuestra Política de privacidad, que detalla cómo utilizamos el
                    Contenido
                    y lo gestionamos internamente. Por favor revíselo detenidamente.</p>
                <h3>Propiedad intelectual</h3>
                <ul>
                    <li>CONDAMIND Propiedad intelectual: Estos Términos no le otorgan ningún derecho, título o interés sobre
                        nuestros Servicios, nuestra marca comercial u otra propiedad intelectual de CONDAMIND.</li>
                    <li>Comentarios: Agradecemos todos y cada uno de los comentarios, ideas de mejora, propuestas de
                        productos y
                        otras sugerencias. Sin embargo, si nos proporciona esto, reconoce que podemos usarlo sin
                        restricciones y
                        sin previo aviso o compensación para usted.</li>
                    <li>Avisos de derechos de autor: si cree que sus derechos de autor han sido infringidos por algo en
                        nuestros
                        Servicios, puede enviarnos un aviso de derechos de autor que cumpla con la DMCA enviando un correo
                        electrónico a matias@condamind.com. Al recibir una notificación de cumplimiento, trabajaremos para
                        eliminar o deshabilitar rápidamente el material identificado como infractor. Por favor incluya la
                        siguiente información en su aviso: <ul>
                            <li>Una descripción de la obra u obras que afirma haber sido infringidas;</li>
                            <li>Una descripción del contenido de nuestros Servicios que usted afirma estar infringiendo;
                            </li>
                            <li>Su información de contacto, incluida la dirección postal, el número de teléfono y la
                                dirección
                                de correo electrónico;</li>
                            <li>Su declaración que confirma una creencia de buena fe de que el uso del material en la forma
                                denunciada no está autorizado por el propietario de los derechos de autor, su agente o la
                                ley;
                            </li>
                            <li>Su declaración confirmando que la información que ha proporcionado es exacta, y bajo pena de
                                perjurio, que está autorizado a actuar en nombre del propietario de un derecho exclusivo que
                                supuestamente se ha infringido;</li>
                            <li>Su firma</li>
                        </ul>
                    </li>
                </ul>
                <h3>Limitación de responsabilidad</h3>
                <p>BAJO NINGUNA CIRCUNSTANCIA Y BAJO NINGUNA TEORÍA JURÍDICA (YA SEA POR CONTRATO, AGRAVIO O DE OTRA MANERA)
                    CONDAMIND SERÁ RESPONSABLE ANTE USTED O TERCEROS POR (A) CUALQUIER DAÑO INDIRECTO, INCIDENTAL, ESPECIAL,
                    EJEMPLAR, CONSECUENTE O PUNITIVO, INCLUYENDO LA PÉRDIDA DE BENEFICIOS, PÉRDIDA DE VENTAS O NEGOCIOS,
                    PÉRDIDA
                    DE DATOS O (B) POR CUALQUIER DAÑO DIRECTO, COSTOS, PÉRDIDAS O RESPONSABILIDADES QUE SUPEREN LOS CIEN
                    ($100)
                    DÓLARES ESTADOUNIDENSES. LAS DISPOSICIONES DE ESTA SECCIÓN ASIGNAN LOS RIESGOS BAJO ESTOS TÉRMINOS ENTRE
                    LAS
                    PARTES, Y LAS PARTES HAN CONFIADO EN ESTAS LIMITACIONES PARA DETERMINAR SI CELEBRAR ESTOS TÉRMINOS.</p>
                <h3>Sin garantías</h3>
                <p>SU USO DEL SERVICIO ES BAJO SU PROPIO RIESGO. EL SERVICIO SE PROPORCIONA “TAL CUAL” Y “SEGÚN
                    DISPONIBILIDAD”.
                    CONDAMIND RENUNCIA EXPRESAMENTE A TODAS LAS GARANTÍAS DE CUALQUIER TIPO, YA SEA EXPRESA, IMPLÍCITA O
                    LEGAL,
                    INCLUYENDO LAS GARANTÍAS IMPLÍCITAS DE COMERCIABILIDAD, IDONEIDAD PARA UN PROPÓSITO PARTICULAR, TÍTULO Y
                    NO
                    INFRACCIÓN.</p>
                <p>CONDAMIND NO OFRECE GARANTÍA DE QUE (A) LOS SERVICIOS CUMPLIRÁN SUS REQUISITOS; (B) LOS SERVICIOS SERÁN
                    ININTERRUMPIDOS, OPORTUNOS, SEGUROS O LIBRES DE ERRORES; (C) LOS RESULTADOS QUE PUEDAN OBTENERSE DEL USO
                    DE
                    LOS SERVICIOS SERÁN EXACTOS O CONFIABLES; O (D) LA CALIDAD DE CUALQUIER PRODUCTO, SERVICIO, INFORMACIÓN
                    U
                    OTRO MATERIAL COMPRADO U OBTENIDO POR USTED A TRAVÉS DEL SERVICIO SATISFARÁ SUS EXPECTATIVAS.</p>
                <h3>Servicios y sitios web de terceros</h3>
                <p>Los Servicios pueden proporcionar enlaces u otro acceso a servicios, sitios web, tecnología y recursos
                    que
                    son proporcionados o puestos a disposición por terceros (los “Servicios de Terceros”). Su acceso y uso
                    de
                    los Servicios de terceros también puede estar sujeto a términos y condiciones adicionales, políticas de
                    privacidad u otros acuerdos con dichos terceros, y es posible que deba autenticarse o crear cuentas
                    separadas para utilizar los Servicios de terceros en los sitios web o a través de las plataformas
                    tecnológicas de sus respectivos proveedores. Para obtener más información sobre las implicaciones de la
                    activación de Servicios de terceros y nuestro uso, almacenamiento y divulgación de información
                    relacionada
                    con usted y su uso de dichos Servicios de terceros dentro del Servicio, consulte nuestra Política de
                    privacidad.</p>
                <p>CONDAMIND no tiene control ni es responsable de dichos Servicios de terceros, incluida la exactitud,
                    disponibilidad, confiabilidad o integridad de la información compartida o disponible a través de
                    Servicios
                    de terceros, o de las prácticas de privacidad de los Servicios de terceros. Le recomendamos que revise
                    las
                    políticas de privacidad de los terceros que brindan Servicios de terceros antes de utilizar dichos
                    servicios. Usted, y no CONDAMIND, será responsable de todos y cada uno de los costos y cargos asociados
                    con
                    su uso de cualquier Servicio de terceros. CondaMInd habilita estos Servicios de terceros simplemente por
                    conveniencia y la integración o inclusión de dichos Servicios de terceros no implica un respaldo o
                    recomendación. Cualquier trato que tenga con terceros mientras utiliza el Servicio es entre usted y el
                    tercero. CONDAMIND no será responsable, directa o indirectamente, de ningún daño o pérdida causada o
                    presuntamente causada por o en conexión con el uso o la dependencia de cualquier Servicio de terceros.
                </p>
                <h3>Cancelar su cuenta</h3>
                <p>CONDAMIND es libre de cancelar o suspender el acceso a su uso de nuestros Servicios en cualquier momento
                    y
                    por cualquier motivo a nuestra discreción. Los motivos de la rescisión pueden incluir nuestra
                    determinación
                    de que usted ha violado estos Términos, cuando determinamos que es necesario garantizar la seguridad del
                    usuario, por razones de cumplimiento legal o cuando creemos que es necesario para proteger los derechos
                    o la
                    propiedad de CONDAMIND.</p>
                <p>También puede solicitar la eliminación de su cuenta comunicándose con matias@condamind.com Tenga en
                    cuenta
                    que, por razones de seguridad y privacidad, podemos solicitar información para verificar su entidad a
                    fin de
                    procesar estas solicitudes.</p>
                <p>Usted acepta que las disposiciones de estos Términos relativas a indemnización, limitaciones de
                    responsabilidad, propiedad intelectual, disputas y arbitraje, y cualquier otro término que, por su
                    naturaleza, deba sobrevivir a la terminación de los Términos, seguirán vigentes.</p>
                <h3>Cambios en los Servicios</h3>
                <p>La inteligencia artificial es un campo que evoluciona rápidamente y CONDAMIND trabaja continuamente para
                    mejorar nuestros Servicios para nuestros usuarios. Esto significa que nuestros Servicios pueden cambiar
                    y
                    cambiarán con el tiempo. CONDAMIND puede aumentar, modificar, discontinuar o suspender cualquier parte
                    de
                    nuestros Servicios en cualquier momento. Trabajaremos para avisarle con antelación cuando corresponda,
                    pero
                    reconoce que esto no siempre será posible.</p>
                <h3>Cambios a estos términos</h3>
                <p>CONDAMIND se reserva el derecho de modificar estos Términos en cualquier momento y por cualquier motivo.
                    Le
                    avisaremos de estos cambios actualizando esta página con los Términos revisados ​​y actualizando la
                    fecha de
                    entrada en vigor. Ninguna otra modificación de los Términos entrará en vigor a menos que se realice por
                    escrito y esté firmada por usted y un representante de CONDAMIND.</p>
                <p>El uso de cualquiera de nuestros Servicios después de dicha modificación de los Términos se considerará
                    una
                    aceptación de todos los cambios a los Términos. Si no está de acuerdo con los Términos revisados, debe
                    dejar
                    de utilizar inmediatamente nuestros Servicios.</p>
                <h2>Términos y Condiciones del Servicio de CONDAMIND</h2>
                <h3>Introducción</h3>
                <p>Estos términos y condiciones rigen el uso de los servicios ofrecidos por CONDAMIND a través de su sitio
                    web
                    https://condamind.com, sus aplicaciones (Conda), y otros medios de comunicación que involucren la
                    marca
                    CONDAMIND o cualquier servicio vinculado a sus políticas de privacidad.</p>
                <h3>Descripción del Servicio:</h3>
                <p>Conda, desarrollado por CONDAMIND, es un chatbot diseñado para asistir a empresas y usuarios individuales
                    en
                    consultas y agendamiento de turnos. Su integración con WhatsApp permite la comunicación directa para
                    realizar consultas sobre documentación, resolver preguntas de clientes y agendar citas.</p>
                <h3>Registro y Cuenta de Usuario</h3>
                <p>La utilización de ciertas funciones de Conda puede requerir registro. Los usuarios deben proporcionar
                    información precisa y actualizada durante el proceso de registro, de acuerdo con nuestra Política de
                    Privacidad.</p>
                <h3>Compromiso con la Privacidad</h3>
                <p>CONDAMIND se compromete a utilizar la información personal proporcionada de acuerdo con las políticas de
                    privacidad detalladas en este documento. Reconocemos la importancia de la transparencia en la
                    recopilación,
                    uso y protección de los datos de nuestros usuarios.</p>
                <h3>Información Recopilada</h3>
                <p>Al utilizar los servicios de CONDAMIND, recopilamos información que puede incluir nombre, número de
                    teléfono,
                    correo electrónico, dirección IP, contenido y metadatos de mensajes, entre otros datos proporcionados
                    por
                    los usuarios.</p>
                <h3>Uso de la Información</h3>
                <p>Utilizamos la información recopilada para los siguientes fines:</p>
                <ul>
                    <li> Proveer y mejorar nuestros servicios.</li>
                    <li> Comunicarnos con los usuarios sobre actualizaciones, alertas y anuncios.</li>
                    <li>Mejorar, personalizar y proteger la plataforma.</li>
                    <li>Investigación y desarrollo para mejorar la experiencia del usuario.</li>
                    <li>Cumplir con obligaciones legales y proteger nuestros derechos y los de los usuarios.</li>
                </ul>
                <p>Además, es importante destacar que, como intermediarios entre el usuario y el negocio deseado, CONDAMIND
                    actúa como intermediario entre el usuario y negocio, facilitando la comunicación al compartir la
                    información
                    recopilada con nuestros clientes (negocios con los cuales los usuarios desean establecer contacto).</p>
                <h3>Compartición de Información</h3>
                <p>No vendemos ni compartimos información personal con terceros para fines publicitarios. Sin embargo,
                    CONDAMIND
                    comparte información al negocio con el que el usuario comunica, con el fin de facilitar y posibilitar
                    dicha
                    interacción.</p>
                <p>Además, podemos compartir información con proveedores de servicios externos o en situaciones de quiebra,
                    cambio de control o cumplimiento legal.</p>
                <h3>Derechos de Privacidad</h3>
                <p>Los usuarios pueden solicitar la eliminación de su cuenta o información personal, así como acceder,
                    corregir
                    o limitar el uso de dicha información. Estos derechos están sujetos a las leyes y regulaciones
                    correspondientes.</p>
                <h3>Seguridad de Datos</h3>
                <p>CONDAMIND implementa medidas de seguridad para proteger la información personal contra acceso no
                    autorizado,
                    pérdida o mal uso. Sin embargo, se reconoce que ningún sistema es completamente infalible.</p>
                <h3>Uso Aceptable</h3>
                <p>Los usuarios deben cumplir con las políticas de uso que prohíben el uso ilegal, dañino, abusivo o la
                    ingeniería inversa de la plataforma, entre otras restricciones detalladas en los términos y condiciones.
                </p>
                <h3>Propiedad Intelectual</h3>
                <p>Los términos y condiciones establecen la propiedad de CONDAMIND sobre sus servicios y la aceptación del
                    uso
                    del contenido generado por los usuarios para mejorar y operar la plataforma.</p>
                <h3>Limitación de Responsabilidad y Garantías</h3>
                <p>Se establece la limitación de responsabilidad y las exenciones de garantías asociadas con el uso de los
                    servicios, dejando claro que el uso de la plataforma es bajo riesgo propio del usuario.</p>
                <h3>Cambios en los Servicios y Términos</h3>
                <p>CONDAMIND se reserva el derecho de modificar los servicios y los términos y condiciones en cualquier
                    momento,
                    notificando a los usuarios sobre tales cambios y su entrada en vigencia.</p>
                <h3>Contacto</h3>
                <p>Para cualquier consulta o inquietud sobre estas políticas, los usuarios pueden comunicarse con el equipo
                    de
                    CONDAMIND a través del correo electrónico matias@condamind.com.</p>
                <h3>Conclusión</h3>
                <p>El uso continuado de los servicios de CONDAMIND después de la modificación de estos términos y
                    condiciones
                    implica la aceptación de los cambios realizados.</p>
                <p>Estos términos y condiciones reflejan fielmente las políticas de privacidad y los lineamientos
                    establecidos
                    por CONDAMIND para sus servicios.</p>
            </div>
            <div className="volver-button">
                <Link className='volver-button' to="/">Volver</Link>
            </div>
        </>
    );
};

export default Terms;